import { render } from "./BasicNavigationControl.vue?vue&type=template&id=cccdf5dc&scoped=true&ts=true"
import script from "./BasicNavigationControl.vue?vue&type=script&lang=ts"
export * from "./BasicNavigationControl.vue?vue&type=script&lang=ts"

import "./BasicNavigationControl.vue?vue&type=style&index=0&id=cccdf5dc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cccdf5dc"]])

export default __exports__